module.exports = __webpack_public_path__ + "assets/img/person-icon.432e493e.png";